import '/home/runner/work/dialog/dialog/docs/demo/with-portal.md?watch=parent';
export const toc = new Proxy([], {});
export const frontmatter = new Proxy({"title":"with-portal","toc":"menu","filename":"docs/demo/with-portal.md","lastUpdated":1785141763000,"nav":{"title":"Demo","path":"/demo"}}, {});

export const demoIndex = {
  ids: ["docs-demo-with-portal-demo-with-portal"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/with-portal.md?type=demo')
};